export default __webpack_public_path__ + "static/media/SBN_TV.3d1f11bb.jpg";